export default "/_next/static/assets/fonts/SourceSansPro-Regular.80c998aa03640281d556814a14e1d9c8.woff2";